module.exports = __webpack_public_path__ + "de9d010646870a3843466867997b730f.svg";